
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ElevenLabsAgent } from "@/types/admin";
import { AgentTableRow } from "./AgentTableRow";

interface AgentTableProps {
  agents: ElevenLabsAgent[];
  onViewAgent: (agent: ElevenLabsAgent) => void;
}

export const AgentTable = ({ agents, onViewAgent }: AgentTableProps) => {
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Agent Name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Agent ID</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Created</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {agents.map((agent) => (
            <AgentTableRow 
              key={agent.agent_id} 
              agent={agent} 
              onViewAgent={onViewAgent} 
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
